import { useState, useEffect, useRef } from 'react';

export const useAudioPlayer = (streamUrl, isActive, onPlay, onPause, globalAudioRef) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(0.8);
  const [isMuted, setIsMuted] = useState(false);
  const audioRef = useRef(null);
  const progressRef = useRef(null);

  const hasAudio = streamUrl && streamUrl !== "";

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = isMuted ? 0 : volume;
    }
  }, [volume, isMuted]);

  useEffect(() => {
    if (!isActive && audioRef.current) {
      audioRef.current.pause();
      setCurrentTime(0);
      audioRef.current.currentTime = 0;
    }
  }, [isActive]);

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const handleProgressClick = (e) => {
    if (!hasAudio || !progressRef.current || !audioRef.current) return;
    const rect = progressRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const newTime = (clickX / rect.width) * duration;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const handlePlayToggle = () => {
    if (!hasAudio) return;
    
    if (isActive) {
      audioRef.current?.pause();
      onPause();
    } else {
      if (globalAudioRef?.current && globalAudioRef.current !== audioRef.current) {
        globalAudioRef.current.pause();
      }
      if (globalAudioRef) {
        globalAudioRef.current = audioRef.current;
      }
      audioRef.current?.play();
      onPlay();
    }
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const mins = Math.floor(time / 60);
    const secs = Math.floor(time % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

  return {
    audioRef,
    progressRef,
    currentTime,
    duration,
    volume,
    isMuted,
    setVolume,
    setIsMuted,
    handleTimeUpdate,
    handleLoadedMetadata,
    handleProgressClick,
    handlePlayToggle,
    formatTime,
    progress,
    hasAudio
  };
};
